import { map } from "lodash";
import GrComponentFactory from "../gr_component_factory";
import Reflux from "reflux";
import NewsfeedUpdateStore, { UpdateFeedPreferences } from "../../react_stores/newsfeed_update_store";
import NewsfeedActions from "../../react_actions/newsfeed_actions";
import ModalActions from "../../react_actions/modal_actions";
import * as newsfeedHelper from "./newsfeed_helper";
import Spinner from "../spinner";
import InfiniteScrollList from "../shared/infinite_scroll_list";
import { getImages } from "../../modules/shared/image_registry";
import Popover from "../shared/popover/popover";

const PREFS_PANE_ID = "grNewsfeedPreferencesPane";

export default GrComponentFactory.createClass({
  displayName: "Newsfeed",

  mixins: [Reflux.connect(NewsfeedUpdateStore, "newsfeedUpdateStore")],

  getInitialState() {
    return {
      showUpdatesFeedPreferencesForm: false,
    };
  },

  getDefaultProps() {
    return {
      showGenresModal: false,
    };
  },

  componentDidMount() {
    // If users have not selected favorite genres, open the genre modal to
    // encourage them to select them now so that we can target them with
    // nonsocial genre newsfeed stories.
    if (this.props.showGenresModal) {
      ModalActions.openModal("favGenres");
    }
  },

  handleUpdateItemChange(event) {
    NewsfeedActions.setUpdatesFeedPreferences({ item: event.target.value });
  },

  handleUpdateScopeChange(event) {
    NewsfeedActions.setUpdatesFeedPreferences({ scope: event.target.value });
  },

  renderLoadMore() {
    const storeState = this.state.newsfeedUpdateStore;
    if (storeState.noAdditionalUpdates) {
      return <span>No More Updates</span>;
    } else {
      if (storeState.loadingInProgress) {
        return <Spinner />;
      } else {
        return <button className="gr-button gr-button--quiet gr-button--fullWidth"
                       onClick={NewsfeedActions.loadMoreUpdates}>
                 Load More Updates
               </button>;
      }
    }
  },

  renderLoadingInProgressMessage() {
    const storeState = this.state.newsfeedUpdateStore;
    if(storeState.loadingInProgress) {
      return <div className="u-textAlignCenter">
        <Spinner isSmall={true} className="u-marginRightTiny"/>
        <small>Refreshing updates…</small>
      </div>;
    }
  },

  renderUpdatesFeedPreferencesForm() {
    const storeState = this.state.newsfeedUpdateStore;
    const updatePreferencesInProgress = storeState.loadingInProgress;

    return <div id={PREFS_PANE_ID}>
      {this.renderLoadingInProgressMessage()}

      <fieldset className="gr-radioButtonGroup">
        <legend>Content</legend>
        <small>What types of updates you see</small>
        {
          map(UpdateFeedPreferences.items, (item) => (
              <label key={item.value} className="gr-radioButtonGroup__choice gr-label gr-label--muted">
                <input name="update_item"
                       value={item.value}
                       disabled={updatePreferencesInProgress}
                       checked={storeState.updatesFeedPreferences.item === item.value }
                       onChange={this.handleUpdateItemChange}
                       type="radio"
                       className="gr-radioButtonGroup__button" />
                {item.label}
              </label>
          ))
        }
      </fieldset>


      <fieldset className="gr-radioButtonGroup">
        <legend>People</legend>
        <small>Whose updates you see</small>
        {
          map(UpdateFeedPreferences.scopes, (scope) => (
              <label key={scope.value} className="gr-radioButtonGroup__choice gr-label gr-label--muted">
                <input name="update_scope"
                       value={scope.value}
                       disabled={updatePreferencesInProgress}
                       checked={storeState.updatesFeedPreferences.scope === scope.value }
                       onChange={this.handleUpdateScopeChange}
                       type="radio"
                       className="gr-radioButtonGroup__button" />
                {scope.label}
              </label>
          ))
        }
      </fieldset>
    </div>;
  },


  togglePreferences() {
    this.setState({
      showUpdatesFeedPreferencesForm: !this.state.showUpdatesFeedPreferencesForm,
    });
  },

  closePreferences() {
    this.setState({
      showUpdatesFeedPreferencesForm: false,
    });
  },

  renderCustomizeFeedButton() {
    const popoverTarget =
      <button className="gr-iconButton u-floatRight"
              aria-label="Customize updates feed preferences"
              aria-haspopup="true"
              aria-expanded={this.state.showUpdatesFeedPreferencesForm}
              aria-controls={PREFS_PANE_ID}
              onClick={this.togglePreferences}>
        <span className="gr-iconButton__innerWrapper">
          <img className="gr-settingsIcon"
               alt=""
               src={getImages().settingsCog} />
          <span className="gr-iconButton__textLabel">
            Customize
          </span>
        </span>
      </button>;

    const preferencesForm = this.renderUpdatesFeedPreferencesForm();
    return <Popover bemModifiers="small"
                    headingText="Updates Feed Preferences"
                    isOpen={this.state.showUpdatesFeedPreferencesForm}
                    showArrow={false}
                    onClose={this.closePreferences}
                    body={preferencesForm}
                    popoverTarget={popoverTarget}/>;
  },

  render() {
    const storeState = this.state.newsfeedUpdateStore;
    const newsfeedUpdates = map(storeState.newsfeedUpdates, (newsfeedUpdate) => <div key={newsfeedUpdate.id}>
               {newsfeedHelper.renderNewsfeedItem(newsfeedUpdate, { 
                allowBehavioralTargeting: this.props.allowBehavioralTargeting,
                urcDeprecateViewChallengeLink: this.props.urcDeprecateViewChallengeLink,
                })}
             </div>);

    return (
      <div className="gr-newsfeed u-defaultType">
        <h3 className="gr-newsfeed__title">Updates</h3>

        {this.renderCustomizeFeedButton()}

        <div className="u-clearBoth">
          <InfiniteScrollList loadMoreAction={NewsfeedActions.loadMoreUpdates}
                              loadingInProgress={storeState.loadingInProgress}
                              noMoreItems={storeState.noAdditionalUpdates}>
            {newsfeedUpdates}
          </InfiniteScrollList>

          <div className="gr-newsfeed__loadMore">
            {this.renderLoadMore()}
          </div>
        </div>
      </div>
    );
  },
});
